import { useCentralStore } from "../../../../store/Central";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from "../../../../components/ui/select";

export const ConnectRelationshipClientSelect: React.FC<{
	onSelect: (connectedOrganizationId: string) => void;
}> = ({ onSelect }) => {
	const { clients } = useCentralStore((state) => ({
		clients: Object.values(state.clientsLookup),
	}));

	const connectRelationshipsClients: {
		label: string;
		value: string;
	}[] = clients
		.filter((client) => client.connected_organization_id)
		.reduce((acc, client) => {
			const value = client.connected_organization_id ?? "";
			const label = client.company_name ??
				client?.title +
				" " +
				client?.first_name +
				" " +
				client?.last_name;

			if (!acc.some(item => item.value === value)) {
				acc.push({ label, value });
			}
			return acc;
		}, [] as { label: string; value: string; }[]);

	return (
		<Select onValueChange={onSelect}>
			<SelectTrigger className="w-full">
				<SelectValue placeholder="Verbindung auswählen" />
			</SelectTrigger>
			<SelectContent className="z-[1400]">
				{connectRelationshipsClients.map((option) => (
					<SelectItem key={option.value} value={option.value}>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
